/**
 * @generated SignedSource<<40491bd1329cd6559a7799bd34b2ac9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MicrosoftTodoImportExistingTicketPaneTaskQuery$variables = {
  listId: string;
  taskId: string;
};
export type MicrosoftTodoImportExistingTicketPaneTaskQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly microsoftTodo: {
        readonly task: {
          readonly externalId: string;
          readonly listId: string;
          readonly listName: string;
          readonly name: string;
        } | null;
      } | null;
    };
  };
};
export type MicrosoftTodoImportExistingTicketPaneTaskQuery = {
  response: MicrosoftTodoImportExistingTicketPaneTaskQuery$data;
  variables: MicrosoftTodoImportExistingTicketPaneTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "listId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "listId",
    "variableName": "listId"
  },
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoImportExistingTicketPaneTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "MicrosoftTodoTaskNode",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MicrosoftTodoImportExistingTicketPaneTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "MicrosoftTodoTaskNode",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "420fbdf21fd746fdeb4b0ef212f84142",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoImportExistingTicketPaneTaskQuery",
    "operationKind": "query",
    "text": "query MicrosoftTodoImportExistingTicketPaneTaskQuery(\n  $listId: String!\n  $taskId: String!\n) {\n  viewer {\n    integrations {\n      microsoftTodo {\n        task(listId: $listId, taskId: $taskId) {\n          name\n          externalId\n          listId\n          listName\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c1e4cc3f2cd84288832bfc9cbe66317";

export default node;
